import React from 'react';

import { getConfigProperty } from 'Common/config';
import { messages } from 'Src/shared/messages';
import { IntlHelmet } from 'Src/utils/intl-helmet';

function SearchMetas({ config, match, searchSummary }) {
  const primaryDomain = getConfigProperty(config, 'primary_domain');
  const host = getConfigProperty(config, 'host');

  const buildCanonicalSeachUrl = (host, match, searchSummary) => {
    const { page = 1 } = searchSummary;
    let path = '';
    if (match.path === '/specialty/:specialty/near/:location') {
      path = `/specialty/${encodeURIComponent(
        decodeURIComponent(match.params.specialty)
      )}/near/${encodeURIComponent(decodeURIComponent(match.params.location))}`;
    } else if (match.path === '/specialty/:specialty') {
      path = `/specialty/${encodeURIComponent(
        decodeURIComponent(match.params.specialty)
      )}`;
    } else if (match.path === '/search') {
      path = '/search';
    }
    return `${host}${path}?page=${page}`;
  };

  const canonicalUrl = buildCanonicalSeachUrl(
    primaryDomain || host,
    match,
    searchSummary
  );

  const searchTerm = searchSummary.search_description || '';
  const location =
    searchSummary.display_location || searchSummary.location || '';

  let titleMessageDescriptor, descriptionMessageDescriptor;
  if (searchTerm && location) {
    titleMessageDescriptor = messages.metaSearchPageTitleWithQueryAndLocation;
    descriptionMessageDescriptor = messages.metaSearchPageDescriptionWithQuery;
  } else if (searchTerm) {
    titleMessageDescriptor = messages.metaSearchPageTitleWithQuery;
    descriptionMessageDescriptor = messages.metaSearchPageDescriptionWithQuery;
  } else {
    titleMessageDescriptor = messages.metaSearchPageTitleBasic;
    descriptionMessageDescriptor = messages.metaSearchPageDescriptionBasic;
  }

  const links = [];

  if (!config?.seo?.disable_canonical_tags_listings_pages) {
    links.push({
      href: canonicalUrl,
      rel: 'canonical'
    });
  }

  return (
    <IntlHelmet
      title={titleMessageDescriptor}
      titleValues={{ searchTerm, location }}
      meta={[
        {
          name: 'description',
          message: descriptionMessageDescriptor,
          values: { searchTerm }
        }
      ]}
      link={links}
    />
  );
}

export default SearchMetas;
